<template>
  <v-card
    v-bind="$attrs"
    :class="classes"
    class="modern-login-card mx-auto pa-8"
    elevation="10"
    max-width="370"
    style="border-radius: 18px; background: #fff;"
    light
  >
    <div class="d-flex flex-column align-center mb-6">
      <img
        class="kon_logo"
        :src="imgLogo2"
        alt="Logo Konsist"
        style="width: 90px; height: auto; margin-bottom: 18px;"
      />
      <div class="text-h5 font-weight-bold mb-2" style="color: #222;">
        Bem-vindo!
      </div>
      <div class="text-caption" style="color: #888;">
        Faça login para continuar
      </div>
    </div>

    <div v-if="status" class="mb-4 font-medium text-sm text-green-600 text-center">
      {{ status }}
    </div>
    <div class="v-card__text px-0">
      <form @submit.prevent="submit">
        <v-text-field
          v-model="email"
          color="primary"
          label="E-mail"
          prepend-inner-icon="mdi-email-outline"
          outlined
          dense
          class="mb-4 modern-input"
          required
        ></v-text-field>
        <v-text-field
          v-model="senha"
          type="password"
          color="primary"
          label="Senha"
          prepend-inner-icon="mdi-lock-outline"
          outlined
          dense
          class="mb-2 modern-input"
          required
        ></v-text-field>

        <div class="d-flex justify-end mb-4">
          <a class="modern-link" @click="dialog = true">Esqueceu a senha?</a>
        </div>

        <v-btn
          elevation="2"
          :loading="loading"
          class="modern-btn"
          type="submit"
          block
          large
        >
          Entrar
        </v-btn>

        <div class="text-center mt-4">
          <a></a>
        </div>
      </form>

      <v-snackbar
        v-model="snackbar"
        top
        :timeout="-1"
        elevation="24"
        color="deep-purple success-4"
      >
        {{ mensagemErro }}

        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>

      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <p>Se este é o seu primeiro acesso,<a 
              v-bind="attrs"
              v-on="on"
              > clique aqui</a>.</p>
              <a @click="openTutorialModal">Ver tutorial</a>
          </template>

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Alteração de senha
            </v-card-title>

            <v-card-text>
              <p>Prezado usuário, </p>

            <p>Por favor, note que o email que você está tentando digitar deve estar previamente cadastrado na clínica. Caso ainda não tenha cadastrado seu email, por favor, entre em contato com nosso suporte da Konsist para que possamos ajudá-lo a cadastrar seu email e ter acesso aos recursos que precisa.</p>
            </v-card-text>
            <v-card-text>
              <v-text-field
              v-model="email_digitado"
              label="Email"
              required
              ></v-text-field>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="mudaSenha(email_digitado), dialog=false"
              >
                Enviar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <slot />

    <template v-if="$slots.actions">
      <v-divider class="mt-2" />

      <v-card-actions class="pb-0">
        <slot name="actions" />
      </v-card-actions>
    </template>
    
    
    <v-dialog
      v-model="selecionaUrl"
      persistent
      max-width="450"
    >
      <v-card class="modern-card">
        <v-card-title class="headline modern-card-title">
          Escolha a clínica
        </v-card-title>

        <v-list>
          <v-list-item
            v-for="item in links"
            :key="item.clienteid"
            link
            @click="selecionarLink(item)"
            class="modern-list-item"
          >
            <v-list-item-icon>
              <v-icon color="#4CAF50">mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              v-text="item.cliente"
              class="modern-list-title"
            ></v-list-item-title>
          </v-list-item>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="modern-btn"
            @click="selecionaUrl = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tutorialModal" max-width="900">
      <template v-slot:activator="{ on, attrs }">
        <!-- O botão/link para abrir o modal -->
        <a v-bind="attrs" v-on="on"></a>
      </template>

      <!-- Conteúdo do modal -->
      <v-card>
        <v-card-title>Guia de Tutorial</v-card-title>
        <v-card-text>
          <!-- Aqui você pode adicionar o GIF tutorial -->
          <img v-if="isMobile" :src="mobileTutorialGif" alt="Tutorial GIF for Mobile">
          <img v-else :src="desktopTutorialGif" alt="Tutorial GIF for Desktop">
        </v-card-text>
        <v-card-actions>
          <!-- Botão para fechar o modal -->
          <v-btn color="primary" @click="tutorialModal = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import VueCookies from "vue-cookies";

export default {
  name: "materialcardlogin",
  components: {},

  props: {
    avatar: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "success",
    },
    icon: {
      type: String,
      default: undefined,
    },
    image: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    imgLogo2: {
      type: String,
      default: require("@/assets/img/logo.png"),
    },

    status: String,
  },

  data() {
    return {
      email: "",
      senha: "",
      loading: false,
      mensagemErro: "",
      snackbar: false,
      erroSenha: false,
      selecionaUrl: false,
      linkSelecionado: null,
      links:[],
      dialog: false,
      mobileTutorialGif: require("@/assets/img/Animacao_iphone.gif"),
      desktopTutorialGif: require("@/assets/img/Animacao.gif"),
      tutorialModal: false
    };
  },

  methods: {
    openTutorialModal() {
      // Método para abrir o modal
      this.tutorialModal = true;
    },
    selecionarLink(item){
      
      if(item == null ){
        //alert("Selecionar Link.");
        this.$notify({
            group: 'foo',
            title: 'Atenção',
            text: 'Selecione uma clínica'
          });
        return;
      }
      
      this.$store.state.configuracoes.urlBackEnd = item.api_endereco;
      this.$store.state.configuracoes.usuarioLogado = item;
      this.$store.state.configuracoes.id = item.id;
      this.$store.state.configuracoes.email = item.email;
      this.$store.state.configuracoes.nome = item.nome;
      this.$store.state.configuracoes.cliente = item.cliente;
      this.$store.state.configuracoes.tokenBack = item.token_api;
      this.$store.state.configuracoes.urlCliente = item.api_endereco;
      this.$store.state.configuracoes.clienteid = item.clienteid;
      this.$store
            .dispatch("usuarioAcesso",{
              idCliente: this.$store.state.configuracoes.clienteid,
              idUsuario: this.$store.state.configuracoes.id,
              nomeTela: "Login",
            });
      this.$cookies.set(
            "token_api",
            this.$store.state.configuracoes.tokenBackLocal
          );
          this.$cookies.set(
            "token_back",
            this.$store.state.configuracoes.tokenBack
          );
          this.$cookies.set(
            "nome_user",
            this.$store.state.configuracoes.nome
          );
          this.$cookies.set(
            "cliente_user",
            this.$store.state.configuracoes.cliente
          );
          this.$cookies.set(
            "url_back",
            this.$store.state.configuracoes.urlCliente
          );
          this.$cookies.set(
            "email_user",
            this.$store.state.configuracoes.email
          );
          this.$cookies.set(
            "cliente_id",
            this.$store.state.configuracoes.clienteid
          );
          this.$cookies.set(
            "usuario_id",
            this.$store.state.configuracoes.id
          );
          this.$router.push("/dashboard");
    },
    mudaSenha(email_digitado, paciente) {
      this.$store.state.configuracoes.loading = true;
      this.$store
        .dispatch("recuperaSenha", {
          urlRecupera: this.$store.state.configuracoes.urlRecupera,
          email: email_digitado,
          linkRecuperar: window.location.origin + "/user",
        })
        .then(() => alert("Email enviado com sucesso"))
        .catch(error => {
          alert(error.response.data); // Exibe a mensagem de erro no alert
        })
        .finally(() => this.$store.state.configuracoes.loading = false);

    },
    submit() {
      this.loading = true;
      var self = this;
      this.$store
        .dispatch("logar", { email: this.email, senha: this.senha })
        .then((data) => {
            if(Array.isArray(data) && data.length > 0){
              this.links = data;
              this.selecionaUrl = true;

              return;
            }
            this.$store.state.configuracoes.tokenBackLocal = data.api_endereco;
          this.$cookies.set(
            "token_api",
            this.$store.state.configuracoes.tokenBackLocal
          );
          this.$cookies.set(
            "token_back",
            this.$store.state.configuracoes.tokenBack
          );
          this.$cookies.set(
            "url_back",
            this.$store.state.configuracoes.urlCliente
          );
          this.$cookies.set(
            "email_user",
            this.$store.state.configuracoes.email
          );
          this.$cookies.set(
            "nome_user",
            this.$store.state.configuracoes.nome
          );
          this.$cookies.set(
            "cliente_user",
            this.$store.state.configuracoes.cliente
          );
          this.$cookies.set(
            "cliente_id",
            this.$store.state.configuracoes.clienteid
          );
          this.$cookies.set(
            "usuario_id",
            this.$store.state.configuracoes.id
          );
          this.$router.push("/dashboard");
        })
        .catch(error => {
          alert(error.response.data.erro); // Exibe a mensagem de erro no alert
        })
        .finally(() => {
          this.senha = "";   // limpa só a senha
          this.loading = false;
        });
    },
  },

  computed: {
    isMobile() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    
    // Calcular a proporção de aspecto da tela
    const aspectRatio = screenWidth / screenHeight;
    
    // Defina um intervalo para a proporção de aspecto de dispositivos móveis em formato retrato (9:16)
    const mobileAspectRatioMin = 9 / 16;
    const mobileAspectRatioMax = 16 / 9;

    // Verifique se a proporção de aspecto está dentro do intervalo de dispositivos móveis
    return aspectRatio >= mobileAspectRatioMin && aspectRatio <= mobileAspectRatioMax;
  },
    classes() {
      return {
        "v-card--material--has-heading": this.hasHeading,
      };
    },
    hasHeading() {
      return Boolean(this.$slots.heading || this.title || this.icon);
    },
    hasAltHeading() {
      return Boolean(this.$slots.heading || (this.title && this.icon));
    },
  },
};
</script>

<style scoped>
.modern-list-item {
  transition: background 0.2s;
  border-radius: 8px;
}

.modern-list-item:hover {
  background: rgba(76, 175, 80, 0.1);
}

.modern-list-title {
  color: #333;
  font-size: 0.95em;
}
.modern-login-card {
  border-radius: 18px !important;
  background: #fff !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.12) !important;
  padding: 40px 32px !important;
  margin-top: 48px;
}

.kon_logo {
  margin-top: 0 !important;
  margin-left: 0 !important;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.modern-input >>> .v-input__slot {
  background: #fff !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 12px !important;     /* mesmo raio do fieldset */
  box-shadow: 0 2px 8px rgba(0,0,0,.06) !important; /* sombra discreta e alinhada */
  overflow: hidden;                    /* evita “vazar” sombra/efeitos internos */
}

.modern-input.v-text-field--outlined >>> fieldset {
  border-radius: 12px !important;      /* igual ao slot */
  border-color: transparent !important;/* esconde o outline serrilhado/notch */
}

/* Zera sombras/resíduos do tema */
.modern-input >>> .v-input__control,
.modern-input >>> .v-input__slot:before,
.modern-input >>> .v-input__slot:after {
  box-shadow: none !important;
}

/* Estados de foco/hover coerentes */
.modern-input.v-input--is-focused >>> .v-input__slot {
  border-color: #66bb6a !important;
  box-shadow: 0 4px 14px rgba(102,187,106,.25) !important;
}
.modern-input:hover >>> .v-input__slot {
  border-color: #cfcfcf !important;
}

.modern-btn {
  background: linear-gradient(90deg, #43a047 0%, #66bb6a 100%) !important; /* verde escuro → verde claro */
  color: #fff !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  letter-spacing: 0.03em;
  transition: box-shadow 0.2s, transform 0.2s;
  box-shadow: 0 2px 8px rgba(67, 160, 71, 0.2); /* sombra verde suave */
}

.modern-btn:hover {
  box-shadow: 0 4px 12px rgba(67, 160, 71, 0.3);
  transform: translateY(-1px);
}

.modern-link {
  color: #ff512f;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.98em;
  transition: color 0.2s;
}

.modern-link:hover {
  color: #dd2476;
}

.text-center {
  text-align: center !important;
}

@media (max-width: 600px) {
  .modern-login-card {
    padding: 24px 8px !important;
    max-width: 98vw !important;
  }
  .kon_logo {
    width: 70px !important;
  }
}

</style>
